<template>
    <div class="c c-dealers">
        <DealerModule assetsFolder="/assets/images/dealers" apiUrl="" apiKey="AIzaSyBvZQJEQT0UdimVyz6CIj04sU_7pWDq7VY" :defaultCountry="settings.cultureShort" :translationsUrl="'/umbraco/api/translations/getalltranslations?locale=' + settings.culture + '&dictionaryKey=Dealers'" :culture="settings.culture" numberOfResults="5" showFilters>
            <template #searchButton="searchButton">
                <button class="btn btn-secondary" type="button" id="searchform" @click="searchButton.search(searchButton.localSearchTerm)">
                    <i class="fal fa-search"></i>
                </button>
            </template>
            <template #filterButton="filterButton">
                <div class="dm-filter__button" @click="filterButton.toggleFilters">
                    <i class="fal fa-angle-down"></i>
                    <span>{{ filterButton.translations.FilterTitle }}</span>
                </div>
            </template>
            <template #filterItem="filterItem">
                <div class="dm-filter__item" v-for="category in filterItem.allCategories" :key="category.Id">
                    <div class="custom-control custom-checkbox flex-grow">
                        <input type="checkbox" class="custom-control-input" :id="'filter' + category.CodeName" :value="category.DisplayName" @change="filterItem.changeFilter(category.DisplayName)" v-model="filterItem.selectedFilters" />
                        <label class="custom-control-label" :for="'filter' + category.CodeName">
                            <img :src="filterItem.getMarker(category.CodeName)" width="18" height="22" />
                            <span>{{ category.DisplayName }}</span>
                        </label>
                    </div>
                    <div class="dm-tooltip" v-if="category.Tooltip !== null" :class="{ open: filterItem.openTooltip }">
                        <div class="dm-tooltip__button" @click="filterItem.toggleTooltip()">
                            <i class="fal fa-info-circle"></i>
                        </div>
                        <div class="dm-tooltip__body">
                            {{ category.Tooltip }}
                        </div>
                    </div>
                </div>
            </template>
            <template #filterPostText="filterPostText">
                <div class="dm-filter__post" v-if="filterPostText.translations.FilterPostText != null" v-html="filterPostText.translations.FilterPostText"></div>
            </template>
            <template #results="results">
                <div class="dm-results__items">
                    <div class="dm-result"
                         @click="results.selectDealer(dealer)"
                         v-for="dealer in results.foundDealers"
                         :key="dealer.Id">
                        <div class="dm-result__distance">
                            <img :src="results.getMarker(dealer.Categories)"
                                 width="30"
                                 height="37" />
                            <span>
                                {{ dealer.Distance.toFixed(1) }}
                                {{ results.translations.Kilometers }}
                            </span>
                        </div>
                        <div class="dm-result__info">
                            <strong>{{ dealer.Name }}</strong><br />{{ dealer.Address }}<br />
                            {{ dealer.Postalcode }}, {{ dealer.City }}
                        </div>
                    </div>
                </div>
            </template>
            <template #resultOverlay="resultOverlay">
                <div class="dm-resultoverlay__button" @click="resultOverlay.clearActiveDealer()">
                    <i class="fal fa-angle-left"></i>
                    <span>{{ resultOverlay.translations.Back }}</span>
                </div>
                <div class="dm-resultoverlay__body">
                    <div class="dm-resultoverlay__label">
                        <span :class="'badge badge-secondary badge-' + resultOverlay.activeDealer.Categories[0].CodeName">{{ resultOverlay.activeDealer.Categories[0].DisplayName }}</span>
                    </div>
                    <div class="dm-resultoverlay__title">{{ resultOverlay.activeDealer.Name }}</div>
                    <div class="dm-resultoverlay__info">
                        <div>{{ resultOverlay.activeDealer.Address }}</div>
                        <div>{{ resultOverlay.activeDealer.Postalcode }}, {{ resultOverlay.activeDealer.City }}</div>
                        <div>{{ resultOverlay.activeDealer.Country }}</div>
                    </div>
                    <div class="dm-resultoverlay__phone" v-if="resultOverlay.activeDealer.Phone !== ''">
                        <i class="fal fa-phone"></i>
                        <span>{{ resultOverlay.activeDealer.Phone }}</span>
                    </div>
                    <a :href="'mailto:' + resultOverlay.activeDealer.EmailAddress" target="_blank" class="dm-resultoverlay__email" v-if="resultOverlay.activeDealer.EmailAddress && resultOverlay.activeDealer.EmailAddress !== ''">
                        <i class="fal fa-envelope"></i>
                        <span>{{ resultOverlay.activeDealer.EmailAddress }}</span>
                        <i class="fal fa-angle-right"></i>
                    </a>
                    <a :href="'https://' + resultOverlay.activeDealer.Website" target="_blank" class="dm-resultoverlay__website" v-if="resultOverlay.activeDealer.Website && resultOverlay.activeDealer.Website !== ''">
                        <i class="fal fa-globe"></i>
                        <span>{{ resultOverlay.translations.VisitWebsite }}</span>
                        <i class="fal fa-angle-right"></i>
                    </a>
                    <a :href="'https://www.google.com/maps/dir//' + resultOverlay.activeDealer.Address.replace(' ', '+') + '+' + resultOverlay.activeDealer.Postalcode.replace(' ', '+') + '+' + resultOverlay.activeDealer.City.replace(' ', '+') + '/@' + resultOverlay.activeDealer.Position.Lat + ',' + resultOverlay.activeDealer.Position.Lng" target="_blank" class="dm-resultoverlay__route">
                        <i class="fal fa-route"></i>
                        <span>{{ resultOverlay.translations.RoutePlanner }}</span>
                        <i class="fal fa-angle-right"></i>
                    </a>
                </div>
            </template>
        </DealerModule>
    </div>
</template>

<script>
    import { DealerModule } from '@frontisbv/frontisdealermodule';

    export default {
        components: {
            DealerModule
        },
        data() {
            return {
            };
        },
        props: {
            settings: {
                type: Object,
                required: true
            }
        }
    };
</script>
